import { useQuery } from "react-query";
import { getGLEntity } from "../../../../actions/Utilities/GLEntity";

export const useGetActiveGLEntity = () => {
  return useQuery("GLEntity", getGLEntity, {
    refetchOnWindowFocus: false,
  });
};
